import React from 'react';
import AnimalNotes from '../shared/AnimalNotes.js';
import AnimalPhotos from '../shared/AnimalPhotos.js';
import Calves from './Calves.js';
import EditableDamSireField from './EditableDamSireField.js';
import DeathCauseDropdown from '../shared/dropdowns/DeathCauseDropdown.js';
import { Fetch } from '../utils/Utils.js';
import { useTranslation } from 'react-i18next';
import './HerdExpandedComponent.css';

export const HerdExpandedComponent = ({ data, onNoteAdded, onRefresh }) => {
  const { t } = useTranslation();
  const isDead = data.is_alive === false;

  const onStatusChange = (e) => {
    const markAsDead = e.target.checked;
    Fetch(`/api/animals/${data.tag}`, 'PATCH',
      JSON.stringify({ is_alive: !markAsDead, death_cause: markAsDead ? (data.death_cause || '') : '' }),
      () => { if (onRefresh) onRefresh(); },
      () => {},
    );
  };

  const onDeathCauseChange = (e) => {
    Fetch(`/api/animals/${data.tag}`, 'PATCH',
      JSON.stringify({ is_alive: false, death_cause: e.target.value }),
      () => { if (onRefresh) onRefresh(); },
      () => { console.log("error updating death cause"); },
    );
  };

  return (
    <div className="herd-expanded">
      <div className="herd-expanded-meta">
        <div className="herd-expanded-meta-item">
          <span className="herd-expanded-meta-label">{t('dam_mother')}</span>
          <span className="herd-expanded-meta-value">
            <EditableDamSireField tag={data.tag} field="dam" value={data.dam} onSaved={onRefresh} />
          </span>
        </div>
        <div className="herd-expanded-meta-item">
          <span className="herd-expanded-meta-label">{t('sire_father')}</span>
          <span className="herd-expanded-meta-value">
            <EditableDamSireField tag={data.tag} field="father" value={data.father} onSaved={onRefresh} />
          </span>
        </div>
        <div className="herd-expanded-meta-item">
          <span className="herd-expanded-meta-label">{t('registered_by')}</span>
          <span className="herd-expanded-meta-value">{data.created_by || '—'}</span>
        </div>
        <div className="herd-expanded-meta-item">
          <span className="herd-expanded-meta-label">{t('registered_from')}</span>
          <span className="herd-expanded-meta-value">{data.phone || '—'}</span>
        </div>
        <div className="herd-expanded-meta-item">
          <span className="herd-expanded-meta-label">{t('registration_date')}</span>
          <span className="herd-expanded-meta-value">{data.registration_date?.substring(0, 10) || '—'}</span>
        </div>
      </div>
      <AnimalNotes data={data} onNoteAdded={onNoteAdded} />
      <AnimalPhotos tag={data.tag} />
      <Calves tag={data.tag} field={data.sex === 'm' ? 'father' : 'dam'} />
      <div className="herd-status-section">
        <label className="herd-death-label">
          <input type="checkbox" checked={isDead} onChange={onStatusChange} />
          {t('mark_as_dead')}
        </label>
        {isDead && (
          <DeathCauseDropdown
            selected={data.death_cause || ''}
            onChange={onDeathCauseChange}
          />
        )}
      </div>
    </div>
  );
};

export default HerdExpandedComponent;
